import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        injectKey: {
            type: String,
            required: true
        }
    },
    render() {
        /* https://vuedose.tips/data-provider-component-in-vue-js */
        return this.$scopedSlots.default?.()
    },
    provide() {

        if(!this.$scopedSlots.default) return {}

        const providedObject = {}

        /*console.log('this.$props', this.$props)
        console.log('this.$attrs', this.$attrs)*/

        Object.keys(this.$attrs).forEach(attrKey => {
            Object.defineProperty(providedObject, attrKey, {
                enumerable: true,
                get: () => this.$attrs[attrKey]
            })
        })

        return {
            [this.injectKey]: providedObject
        }
    }
})
